// Add your custom JS here.

/// //////////////////////////////////////////////////////////////////

/// Onclick at ACCOUNT, show login form for guest

/// //////////////////////////////////////////////////////////////////
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal from 'bootstrap/js/dist/modal';
import intlTelInput from 'intl-tel-input';
import EmailGenie from 'email-genie';
import Collapse from 'bootstrap/js/dist/collapse'
jQuery('body').on('click', '.aj_sigin_up_btn', (event) => {
    event.preventDefault();
    jQuery('.loader-form-ajax').show();
    const user_name = jQuery('#untamed_username').val();
    const user_pass = jQuery('#untamed_password').val();
    const data = new FormData();
    data.append('user_login_name', user_name);
    data.append('user_password', user_pass);
    data.append('action', 'ajx_login_user_action');
    const ajax_url = my_ajax_object.ajax_url;
    jQuery.ajax({
        type: 'post',
        url: ajax_url,
        data,
        dataType: 'JSON',
        cache: false,
        processData: false,
        contentType: false,
        success(res) {
            console.log(res.status);
            if (res.status == 'success') {
                jQuery('.result-message').addClass('sucess');
                sessionStorage.setItem('login', true);
                location.reload();
            } else if (res.status == 'error') {
                jQuery('.loader-form-ajax').hide();
                const responce = res.message;
                jQuery('.result-message').addClass('error');
                jQuery('.result-message').html(responce);
            }
        },
    });
});
let login = sessionStorage.getItem('login');
if (login == 'true') {
    let offcanvas1 = new Offcanvas(document.getElementById('offcanvasLogin'));
    offcanvas1.show();
    jQuery('#header_id').addClass('bg-primary');
    sessionStorage.setItem('login', false);
}
jQuery(document).on('click', '.dropdown-menu', (e) => {
    e.stopPropagation();
});

jQuery(document).ready(() => {
    // Increase Quantity in Cart
    jQuery(document).on('click', '._ci_qty .plus', function() {
        let product = jQuery(this).parent().data('product');
        let productType = jQuery(this).parent().data('type');
        var qty =
            Number.parseInt(jQuery(this).parent().find('input').val()) + 1;
        if (productType == 'composite') {
            jQuery('.mini-cart-error').show();
        } else {
            jQuery('.click-' + product).show();

            let key = jQuery(this).parent().data('itmkey');
            let id = jQuery(this).parent().data('productId');
            updateQty(key, qty, id);
        }
    });
    // Descrease Quantity in Cart
    jQuery(document).on('click', '._ci_qty .minus', function() {
        let product = jQuery(this).parent().data('product');
        jQuery('.click-' + product).show();
        let qty =
            Number.parseInt(jQuery(this).parent().find('input').val()) - 1;
        let key = jQuery(this).parent().data('itmkey');
        let id = jQuery(this).parent().data('productId');
        updateQty(key, qty, id);
    });

    jQuery(document).on('click', '.remove_in_checkout', function() {
        let id = jQuery(this).data('product_id');
        let key = jQuery(this).data('itmkey');
        updateQty(key, 0, id);
    });

    function checkRemoveProduct(id) {
        let array_products_give_access_to_membership_prices = my_ajax_object.array_products_give_access_to_membership_prices;
        if (array_products_give_access_to_membership_prices.includes(id)) {
            let product_id = jQuery('#add_to_cart_simple').data('product_id');
            showOrHidenSinglePriceCircleMember(product_id);
        }
    }

    jQuery(document.body).on('added_to_cart', function(event, fragments, cart_hash, data) {
        if (jQuery('body').hasClass('single-product')) {
            let circleMember = data.data('circleMember');
            let product_id = data.data('product_id');
            // Get the product name
            if (circleMember == "annual") {
                showOrHidenSinglePriceCircleMember(product_id);
            }
        }
    });


    function showOrHidenSinglePriceCircleMember(product_id) {
        const ajax_url = my_ajax_object.ajax_url;
        jQuery.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'show_or_hiden_single_price_circle_member',
                product_id: product_id,
            },
            success: function(data) {
                jQuery('div.add-to-cart-simple-form').html(data);
                if (jQuery('#accordionCircleMember').length) {
                    jQuery('#add_to_cart_simple').data("circleMember", "annual");
                    changeChoiseCircleMember();
                }
            }
        });
    }

    function updateQty(key, qty, id) {
        var url = my_ajax_object.ajax_url;
        jQuery('.widget_shopping_cart_content').css('opacity', '1');
        var data = {
            action: 'updateCartItem',
            cart_item_key: key,
            cart_item_qty: qty,
        };
        jQuery.post(url, data).done((data) => {
            console.log(data);
            jQuery(document.body).trigger('update_checkout');
            updateCartFragment();
            jQuery('.widget_shopping_cart_content').css('opacity', '1');
            if (jQuery('body').hasClass('single-product')) {
                checkRemoveProduct(id);
            }
        });
    }

    jQuery(document).ready(function($) {
        if (!$('body').hasClass('page-template-checkout-template')) {
            $('body').on('added_to_cart', function() {
                updateCartFragment();
                let offcanvasBag = $('#offcanvasBag');
                if ($(window).innerWidth() < 576) {
                    // $('.cart-notifications').slideDown().delay(7000).slideUp();
                } else if (!offcanvasBag.hasClass('show')) {
                    let offcanvas = new Offcanvas($('#offcanvasBag'));
                    offcanvas.show();
                }
            });
        }
    });

    function updateCartFragment() {
        var fragment_refresh = {
            url: woocommerce_params.ajax_url,
            type: 'POST',
            data: {
                action: 'woocommerce_get_refreshed_fragments',
            },
            success(data) {
                if (data && data.fragments) {
                    jQuery.each(data.fragments, (key, value) => {
                        jQuery(key).replaceWith(value);
                    });
                    jQuery('.loader-qty-ajax').hide();
                    jQuery('body').trigger('wc_fragments_refreshed');
                    if (
                        jQuery(
                            '.woocommerce-checkout.page-template-checkout-template'
                        ).length &&
                        data.fragments.checkout == 0
                    ) {
                        window.location.href = '/#cart';
                    }
                }
            },
        };
        // Always perform fragment refresh
        jQuery.ajax(fragment_refresh);
    }

    /////////////////////////////////////////////////////////////
    // SHOW HIDE PASSWORD IN LOGIN FORM
    let getCountry = Cookies.get('theuntamed_country');
    let translateText = {
        AT: ['HIDE', 'SHOW'],
        BE: ['HIDE', 'SHOW'],
        BG: ['HIDE', 'SHOW'],
        HR: ['HIDE', 'SHOW'],
        CZ: ['HIDE', 'SHOW'],
        DK: ['HIDE', 'SHOW'],
        EE: ['HIDE', 'SHOW'],
        FI: ['HIDE', 'SHOW'],
        FR: ['CACHER', 'MONTRER'],
        DE: ['HIDE', 'SHOW'],
        HU: ['HIDE', 'SHOW'],
        IE: ['HIDE', 'SHOW'],
        IT: ['HIDE', 'SHOW'],
        LV: ['HIDE', 'SHOW'],
        LT: ['HIDE', 'SHOW'],
        LU: ['HIDE', 'SHOW'],
        NL: ['HIDE', 'SHOW'],
        NG: ['HIDE', 'SHOW'],
        NO: ['HIDE', 'SHOW'],
        PL: ['UKRYJ', 'POKAŻ'],
        PT: ['HIDE', 'SHOW'],
        RO: ['HIDE', 'SHOW'],
        SK: ['HIDE', 'SHOW'],
        SI: ['HIDE', 'SHOW'],
        ES: ['ESCONDER', 'MOSTRAR'],
        SE: ['HIDE', 'SHOW'],
    };
    let country = translateText[getCountry];
    jQuery('#showhidepass').on('click', (e) => {
        const passInput = jQuery('#untamed_password');
        if (passInput.attr('type') === 'password') {
            passInput.attr('type', 'text');
            if (country) {
                jQuery('#showhidepass').text(country[0]);
            } else {
                jQuery('#showhidepass').text('HIDE');
            }
        } else {
            passInput.attr('type', 'password');
            if (country) {
                jQuery('#showhidepass').text(country[1]);
            } else {
                jQuery('#showhidepass').text('SHOW');
            }
        }
    });

    jQuery('.woocommerce-form-login #username').focus(function() {
        jQuery('.woocommerce-form-login .form-row-first label').hide();
    });
    jQuery('.woocommerce-form-login #password').focus(function() {
        jQuery('.woocommerce-form-login .form-row-last label').hide();
    });
    jQuery('.woocommerce-form-login #username').focusout(function() {
        if (!jQuery('.woocommerce-form-login #username').val())
            jQuery('.woocommerce-form-login .form-row-first label').show();
    });
    jQuery('.woocommerce-form-login #password').focusout(function() {
        if (!jQuery('.woocommerce-form-login #password').val())
            jQuery('.woocommerce-form-login .form-row-last label').show();
    });

    /////////////////////////////////////////////////////////////
    // DEFINE NAVBAR HEIGHT BASED ON LOGGED IN ADMIN OR NON ADMIN
    // No need for body top padding as we change the sturcture of header
    // var el_autohide = jQuery('header');
    // if (jQuery(window).scrollTop() > 10) {
    //     jQuery('.logo_container').hide();
    // } else {
    //     jQuery('.logo_container').show();
    // }
    // if (
    //     jQuery('body').hasClass('page-template-home-template') ||
    //     jQuery('body').hasClass('home')
    // ) {
    //     // Hide navbar logo when open home page first time
    //     jQuery('.navbar-brand-untamed').hide();
    // } else if (jQuery('body').hasClass('woocommerce-checkout')) {
    //     jQuery('.navbar-brand-untamed').show();
    //     jQuery('header nav').removeClass('bg-primary');
    // } else {
    //     jQuery('header nav').addClass('bg-primary');
    //     jQuery('.navbar-brand-untamed').show();
    // }
    // if (el_autohide.length) {
    //     var last_scroll_top = 0;
    //     jQuery(window).on('scroll', function (e) {
    //         var scroll_top = jQuery(this).scrollTop();
    //         el_autohide.addClass('sticky-top');
    //         if (scroll_top > 10) {
    //             if (
    //                 jQuery('body').hasClass('page-template-home-template') ||
    //                 jQuery('body').hasClass('home')
    //             ) {
    //                 jQuery('.b_logo').animate({
    //                     maxWidth: 0,
    //                     top: -330,
    //                 }, {
    //                     duration: 400
    //                 });
    //             } else {}
    //         }
    //         if (jQuery('body').hasClass('woocommerce-checkout')) {} else {
    //             if (scroll_top <= 72) {
    //                 el_autohide.removeClass('scrolled-down');
    //             } else if (scroll_top < last_scroll_top) {
    //                 if (
    //                     jQuery('body').hasClass(
    //                         'page-template-home-template'
    //                     ) ||
    //                     jQuery('body').hasClass('home')
    //                 ) {
    //                     jQuery('.logo_col').removeClass('vh-100');
    //                 }
    //                 el_autohide.removeClass('scrolled-down');
    //                 el_autohide.addClass('sticky_header');
    //                 jQuery('body').addClass('fixed-header');

    //                 if (jQuery('body').hasClass('woocommerce-checkout')) {} else {
    //                     jQuery('header nav').addClass('bg-primary');
    //                 }
    //                 jQuery('.navbar-brand-untamed').show();
    //             } else {
    //                 if (jQuery('.offcanvas').hasClass('show')) {} else {
    //                     el_autohide.removeClass('sticky_header');
    //                     el_autohide.addClass('scrolled-down');
    //                 }
    //                 jQuery('body').removeClass('fixed-header');
    //             }
    //             last_scroll_top = scroll_top;
    //             if (scroll_top <= 0) {
    //                 el_autohide.removeClass('sticky-top');
    //                 el_autohide.removeClass('sticky_header');
    //                 if (
    //                     jQuery('body').hasClass(
    //                         'page-template-home-template'
    //                     ) ||
    //                     jQuery('body').hasClass('home')
    //                 ) {
    //                     jQuery('header nav').removeClass('bg-primary');
    //                 } else {}
    //             }
    //         }
    //     });
    // }

    jQuery('.country-select').on('change', function(e) {
        if (window.location.search) {
            window.location.search += '&country=' + this.value;
        } else {
            window.location.search += '?country=' + this.value;
        }
    });
    jQuery('.country-btn').on('click', function(e) {
        if (window.location.search) {
            window.location.search +=
                '&country=' + jQuery(this).attr('data-country-code');
        } else {
            window.location.search +=
                '?country=' + jQuery(this).attr('data-country-code');
        }
    });
    if (jQuery('.btn-copy').length > 0) {
        new ClipboardJS('.btn-copy');
    }
});
jQuery(document).on('click', '#readMore, #readLess', function() {
    jQuery('.collapsed-content').toggle();
    jQuery('.full-content').toggle();
    jQuery('#readMore').toggle();
});
jQuery(document).on('click', '.btn-save-account', function() {
    jQuery('.btn-save-account .spinner-border').show();
});
// Hidden iframe pay
if (jQuery('.woocommerce-order-pay #place_order').length > 0) {
    jQuery('.woocommerce-order-pay').addClass('hidden-iframe');
}

jQuery(document).ready(function($) {
    function setNumberLinesText(elem, number, сharacters) {
        $(elem).each(function() {
            if (
                $(this).length > 0 &&
                $.trim($(this).html()).length < сharacters
            ) {
                let words = $.trim($(this).html()).split(' ');
                let countWords = (words.length + 1) / number;
                countWords = countWords.toFixed();
                let newhtml = [];
                for (let i = 0; i < words.length; i++) {
                    if (
                        (i > 0 && i == countWords) ||
                        i == countWords * (number - 1)
                    )
                        newhtml.push('<br/>');
                    newhtml.push(words[i]);
                }
                $(this).html(newhtml.join(' '));
            }
        });
    }

    setNumberLinesText('.title-words', 2, 35);
    setNumberLinesText('.two-line-text', 2, 35);
    if ($(window).innerWidth() >= 1000 || $(window).innerWidth() <= 576) {
        setNumberLinesText(
            '.product-grid-type-2-block .two-line-text-all',
            2,
            2000
        );
    }
    // Same height div
    function sameHeight(elem) {
        let maxHeight = 0;
        $(elem).each(function() {
            if ($(this).height() > maxHeight) {
                maxHeight = $(this).height();
            }
        });
        $(elem).height(maxHeight);
    }
    if ($(window).innerWidth() >= 768) {
        sameHeight('.page-template-enrollment-template .card__title');
        sameHeight('.page-template-enrollment-template .card__price');
        // sameHeight('.featured__title');
    }
    if ($(window).innerWidth() <= 576) {
        sameHeight('#carouselProduct .carousel-item img');
        sameHeight('#carouselProduct .carousel-item');
    }
    sameHeight('.page-template-enrollment-template .slider__title');
    // sameHeight('.collection-product__title');

    //Floating labels to checkout fields
    jQuery('.input-cotainer-floating .woocommerce-input-wrapper').addClass(
        'form-floating'
    );
    jQuery('.form-floating select').addClass('form-select');
    jQuery('.input-cotainer-floating label').addClass('label-floating');
    jQuery('.input-cotainer-floating label.label-floating').removeClass(
        'screen-reader-text'
    );
    jQuery('label[for="billing_country"]').insertAfter(
        jQuery('.page-template-checkout-template #billing_country')
    );
    jQuery('label[for="shipping_country"]').insertAfter(
        jQuery('.page-template-checkout-template #shipping_country')
    );
    jQuery('form.checkout .label-floating').each(function() {
        jQuery(this).insertAfter(jQuery(this).parent().find('input'));
        jQuery(this).insertAfter(
            jQuery(this).parent().find('.select2-container')
        );
        jQuery(this).insertAfter(
            jQuery(this).parent().find('.form-control-station')
        );
    });
    // Change width select
    function changeWidth(elem) {
        let text = $(elem).find('option:selected').text();
        let $aux = $('<select/>').append($('<option/>').text(text));
        $(elem).after($aux);
        $(elem).width($aux.width() + 5);
        $aux.remove();
    }

    if ($(window).innerWidth() >= 576) {
        changeWidth('._footer_lng_selector .countrypicker');
        $('._footer_lng_selector .countrypicker').change(function() {
            changeWidth('._footer_lng_selector .countrypicker');
        });
    }

    function updateStationList(
        inputId,
        action,
        inputIdStationName,
        parentClass
    ) {
        jQuery(inputId).on('change', function() {
            let state = $(inputId);
            let data = {
                action: action,
                data: state.serialize(),
            };
            jQuery.ajax({
                type: 'POST',
                url: wc_checkout_params.ajax_url,
                data: data,
                success: function(data) {
                    if ($(inputIdStationName)) {
                        $(inputIdStationName).remove();
                    }
                    $(parentClass).append(data);
                },
            });
        });
    }
    updateStationList(
        '#billing_state',
        'woocommerce_add_station',
        '#billing_station_name_field',
        '.woocommerce-billing-fields'
    );
    updateStationList(
        '#shipping_state',
        'woocommerce_add_shipping_station',
        '#shipping_station_name_field',
        '.shipping_address'
    );
});
// const logo = document.getElementById("main-logo");
// const appHeight = () => {
//     logo.style.height = `${window.innerHeight}px`;
// }
// if (logo) {
//     window.addEventListener('resize', appHeight);
//     appHeight();
// }

jQuery(document).on('click', '#load-more', function() {
    jQuery('.load-more-content').toggle();
    jQuery('#load-more').hide();
});

// Customer Service block load more
jQuery(document).on('click', '.navigation-item', function() {
    let url = this.href;
    let id = url.substring(url.indexOf('#') + 1);
    let elem = jQuery('#' + id);
    if (elem.parent().is(':hidden')) {
        elem.parent().toggle();
        jQuery('#load-more').hide();
    }
});

jQuery(document).ready(function($) {
    let input = $('#billing_address_1');
    if (input.length > 0) {
        let timer = setInterval(function() {
            if (input.attr('autocomplete') == 'off') {
                input.attr('autocomplete', 'chrome-off');
                setTimeout(function() {
                    if (input.attr('autocomplete') == 'chrome-off') {
                        clearInterval(timer);
                    }
                }, 1000);
            }
        }, 2000);
    }

    let country_keys = Object.keys(sell_to_countries.countries);

    const billing_phone = document.querySelector('#phone-show');
    $('.page-template-checkout-template #phone_field-show').append(
        '<span id="valid-msg" class="d-none valid-msg">✓ Valid</span> <span id="error-msg" class="d-none error-msg"></span>'
    );

    const shipping_phone = document.querySelector('#shipping_phone');
    $('.page-template-checkout-template #shipping_phone_field').append(
        '<span id="valid-msg_shipping" class="d-none valid-msg">✓ Valid</span> <span id="error-msg_shipping" class="d-none error-msg"></span>'
    );

    function addedCountryFlag(field_phone, error_id, valid_id, submit_id, send_field_phone, disable_button = false) {
        if (field_phone) {
            let errorMsg = document.querySelector(error_id),
                validMsg = document.querySelector(valid_id);

            let errorMap = [
                'Invalid number',
                'Invalid country code',
                'Too short',
                'Too long',
                'Invalid number',
            ];
            let initialCountry = Cookies.get('theuntamed_country');

            if (!country_keys.some((item) => item === initialCountry)) {
                initialCountry = country_keys[0];
            }
            const phoneInput = intlTelInput(field_phone, {
                initialCountry: initialCountry,
                onlyCountries: country_keys,
                utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.1.7/js/utils.js?1638200991544',
            });



            let reset = function() {
                field_phone.classList.remove('error');
                console.log(errorMsg);
                errorMsg.innerHTML = '';
                errorMsg.classList.add('d-none');
                validMsg.classList.add('d-none');
            };


            function validateNumber() {
                reset();
                let submitButton = document.querySelector('#' + submit_id);
                if (field_phone.value.trim()) {
                    if (phoneInput.isValidNumber()) {
                        validMsg.classList.remove('d-none');
                        submitButton.value = 1;
                        if (disable_button) {
                            submitButton.disabled = false;
                        }
                    } else {
                        field_phone.classList.add('error');
                        var errorCode = phoneInput.getValidationError();
                        errorMsg.innerHTML = errorMap[errorCode];
                        errorMsg.classList.remove('d-none');
                        submitButton.value = 0;
                        if (disable_button) {
                            submitButton.disabled = true;
                        }
                    }
                }
            }

            function process() {

                let phoneNumber = phoneInput.getNumber();
                field_phone.value = phoneNumber;
                if (send_field_phone) {
                    send_field_phone.value = phoneNumber;
                }
            }

            field_phone.addEventListener('blur', validateNumber, false);
            field_phone.addEventListener('blur', process, false);

            let checkoutForm = $('#form-checkout');
            checkoutForm.append(
                '<input id=' +
                submit_id +
                ' type="hidden" name=' + submit_id + ' value="1">'
            );
            checkoutForm.submit(function() {
                validateNumber();
                process();
            });
            // on keyup / change flag: reset
            field_phone.addEventListener('change', reset);
            field_phone.addEventListener('keyup', reset);
        }
    }
    const calendly_phone = document.querySelector('.calendly-block #phone');
    let field_billing_phone = document.querySelector('#billing_phone');
    let field_shipping_phone = document.querySelector('#shipping_phone');
    const account_billing_phone = document.querySelector('#billing_phone_account');
    addedCountryFlag(
        billing_phone,
        '#error-msg',
        '#valid-msg',
        'prevent_submit',
        field_billing_phone
    );
    addedCountryFlag(
        shipping_phone,
        '#error-msg_shipping',
        '#valid-msg_shipping',
        'prevent_submit_shipping',
        field_shipping_phone
    );

    addedCountryFlag(
        calendly_phone,
        '.calendly-block #error-msg',
        '.calendly-block #valid-msg',
        'btn_phone',
        false
    );

    addedCountryFlag(
        account_billing_phone,
        '#error-msg',
        '#valid-msg',
        'btn-save-account',
        false,
        true
    );

    if (window.location.href == 'https://de.theuntamed.com/join/' ||
        window.location.href == 'https://cz.theuntamed.com/join/' ||
        window.location.href == 'https://ng.theuntamed.com/join/'
    ) {
        if (document.querySelector('#cookie-notice') != null) {
            document.querySelector('#cookie-notice').classList.add('d-none');
        }
        Cookies.set(
            'theuntamed_country',
            Object.keys(sell_to_countries.countries)[0], { domain: 'theuntamed.com' }
        );
    }

    if (!Cookies.get('theuntamed_country') &&
        window.location.href != 'https://de.theuntamed.com/join/' &&
        window.location.href != 'https://cz.theuntamed.com/join/' &&
        window.location.href != 'https://ng.theuntamed.com/join/' &&
        window.location.href != 'https://theuntamed.com/leaflets/'
    ) {
        var myModal = new Modal(document.getElementById('staticBackdrop'), {
            keyboard: false,
        });
        myModal.show();
        document.querySelector('#close-modal-country').classList.add('d-none');
        if (document.querySelector('#cookie-notice')) {
            document.querySelector('#cookie-notice').classList.add('d-none');
        }
    }
    if (Cookies.get('theuntamed_country') &&
        window.location.href != 'https://de.theuntamed.com/join/' &&
        window.location.href != 'https://cz.theuntamed.com/join/' &&
        window.location.href != 'https://ng.theuntamed.com/join/'
    ) {
        document.querySelector('#cookie-notice').classList.remove('d-none');
    }
    if (document.querySelector('#email-show')) {
        let allDomains = {
            All: [
                'gmail.com',
                'hotmail.com',
                'icloud.com',
                'live.com',
                'mail.com',
                'me.com',
                'msn.com',
                'outlook.com',
                'rocketmail.com',
                'yahoo.com',
                'ymail.com',
                'laposte.net',
                'hotmail.co.uk',
                'yahoo.co.uk',
                'uwyo.edu',
            ],
            DE: ['hotmail.de', 'outlook.de', 'web.de', 'yahoo.de'],
            ES: ['hotmail.es', 'outlook.es'],
            FR: [
                'hotmail.fr',
                'live.fr',
                'orange.fr',
                'outlook.fr',
                'yahoo.fr',
            ],
            PL: ['interia.pl', 'o2.pl', 'op.pl', 'poczta.onet.pl', 'wp.pl'],
            IT: ['hotmail.it', 'libero.it', 'outlook.it'],
            BE: ['hotmail.be', 'outlook.be', 'yahoo.be'],
            NL: ['hotmail.nl', 'live.nl'],
            SE: ['live.se'],
            DK: ['outlook.dk'],
        };
        let countryCode = Cookies.get('theuntamed_country');
        let domains = allDomains.All;
        if (countryCode && allDomains[countryCode]) {
            domains = [...allDomains.All, ...allDomains[countryCode]];
        }
        let emailField = new EmailGenie('#email-show', {
            domains: domains,
            overrideDomains: true,
            insert: 'afterend',
        });
    }
    if (jQuery('.woocommerce-checkout #billing_vdi_field')) {
        jQuery('.woocommerce-checkout #billing_vdi_field').insertAfter(
            jQuery('.woocommerce-checkout #billing_company_field')
        );
    }

    let billing_email = document.querySelector('#email-show');
    if (billing_email) {
        function autocompleteHide() {
            let list = document.querySelector('datalist option');
            if (list && list.value === billing_email.value) {
                list.remove();
            }
        }
        billing_email.addEventListener('keyup', autocompleteHide);
    }
    // MailChimp form
    ajaxMailChimpForm($('#subscribe-form'), $('#subscribe-result'));

    function ajaxMailChimpForm($form, $resultElement) {
        $form.submit(function(e) {
            e.preventDefault();
            if (!isValidEmail($form)) {
                var error = 'A valid email address must be provided.';
                $resultElement.html(error);
                $resultElement.css('color', 'red');
            } else {
                $resultElement.html('Subscribing...');
                submitSubscribeForm($form, $resultElement);
            }
        });
    }
    // Validate the email address in the form
    function isValidEmail($form) {
        var email = $form.find("input[type='email']").val();
        if (!email || !email.length) {
            return false;
        } else if (email.indexOf('@') == -1) {
            return false;
        }
        return true;
    }
    // Submit the form with an ajax/jsonp request
    function submitSubscribeForm($form, $resultElement) {
        $.ajax({
            type: 'GET',
            url: $form.attr('action'),
            data: $form.serialize(),
            cache: false,
            dataType: 'jsonp',
            jsonp: 'c',
            contentType: 'application/json; charset=utf-8',
            error: function(error) {},
            success: function(data) {
                if (data.result != 'success') {
                    var message =
                        data.msg ||
                        'Sorry. Unable to subscribe. Please try again later.';
                    $resultElement.css('color', 'red');

                    if (
                        data.msg &&
                        data.msg.indexOf('already subscribed') >= 0
                    ) {
                        message = "You're already subscribed. Thank you.";
                    }

                    $resultElement.html(message);
                } else {
                    $resultElement.html('Thank you!');
                }
            },
        });
    }
    jQuery('.offcanvas').on('show.bs.offcanvas', function() {
        jQuery('#header_id').addClass('bg-primary');
    });
    jQuery('.offcanvas').on('hide.bs.offcanvas', function() {
        jQuery('#header_id').removeClass('bg-primary');
    });

    //Show sponsor name
    function showSponsorName() {
        if (!!jQuery('#wc_integration_sponsor_referral_code').val()) {
            jQuery.ajax({
                type: 'get',
                url: my_ajax_object.mlmsoft_url + '/api3/account/search/by-invite-code',
                data: {
                    inviteCode: jQuery(
                        '#wc_integration_sponsor_referral_code'
                    ).val(),
                },
                success(res) {
                    jQuery('#wc_integration_sponsor_referral_name').text(
                        res.payload.title
                    );
                },
                error(res) {
                    if (res.responseJSON.error.code == 400) {
                        jQuery('#wc_integration_sponsor_referral_name').text(
                            res.responseJSON.error.fields.inviteCode
                        );
                    } else {
                        jQuery('#wc_integration_sponsor_referral_name').text(
                            res.responseJSON.error.description
                        );
                    }
                },
            });
        } else {
            jQuery('#wc_integration_sponsor_referral_name').text('');
        }
    }

    jQuery('#wc_integration_sponsor_referral_code_field').append(
        "<div id='wc_integration_sponsor_referral_name' class='pt-1'></div>"
    );
    showSponsorName();
    jQuery('#wc_integration_sponsor_referral_code').on(
        'change',
        showSponsorName
    );
});
document.querySelectorAll('.multi-carousel').forEach((carousel) => {
    const items = carousel.querySelectorAll('.carousel-item'); 

    items.forEach((el) => {
        const minPerSlide = 4;
        let next = el.nextElementSibling;
        
        for (let i = 1; i < minPerSlide; i++) {
            if (!next) {
                next = items[0];
            }
            
            const cloneChild = next.cloneNode(true); 
            el.appendChild(cloneChild.children[0]); 
            next = next.nextElementSibling; 
        }
    });
});


function offCanvasListener(offCanvasId) {
    let myOffCanvas = document.getElementById(offCanvasId);

    const hideCanvas = () => {
        let openedCanvas = Offcanvas.getInstance(myOffCanvas);
        openedCanvas.hide();
    };
    const listenToMouseLeave = (event) => {
        event.target.addEventListener('mouseleave', hideCanvas);
    };
 
    myOffCanvas.addEventListener('shown.bs.offcanvas', listenToMouseLeave);
}

jQuery(document).ready(function($) {
    function showOffcanvas($this, idOpenOffcanvas, idCloseOffcanvas) {
        if (!$($this).hasClass('open-hover')) {
            $($this).addClass('open-hover');
            let openedCanvas = Offcanvas.getInstance($(idCloseOffcanvas));
            if (openedCanvas && idOpenOffcanvas === idCloseOffcanvas) {
                openedCanvas.show();
            } else {
                if (openedCanvas) {
                    openedCanvas.hide();
                }
                let offcanvas = new Offcanvas($(idOpenOffcanvas));
                offcanvas.show();
            }
        }
    }

    function showMenu(btn, idOpenOffcanvas, idCloseOffcanvas, openOffcanvas) {
        $(idOpenOffcanvas).on('hidden.bs.offcanvas', function() {
            $(btn).removeClass('open-hover');
        });
        offCanvasListener(openOffcanvas);
    }

    $('#menu').click(function() {
        console.log("click");
        $('#menu').toggleClass('open-menu');
    });
   
    // show menu
    // showMenu(
    //     '#btn-menu',
    //     '#offcanvasMenu',
    //     '#offcanvasMenu',
    //     'offcanvasMenu'
    // );

    // // show menu Community
    // showMenu(
    //     "a.header-nav-link[href='#']",
    //     '#offcanvasMenu',
    //     '#offcanvasMenu',
    //     'offcanvasMenu'
    // );

    const menuOffcanvas = $('.offcanvas-top');
    menuOffcanvas.on('show.bs.offcanvas', function() {
        let scrollWidth = window.innerWidth - $(document).width();
        $('#wrapper-navbar').css('padding-right', scrollWidth + 'px');
    });
    menuOffcanvas.on('hidden.bs.offcanvas', function() {
        $('#wrapper-navbar').css('padding-right', '0');
    });
   
});

jQuery(document).ready(function($) {
    if ($('.page-template-checkout-template ')) {
        let checkboxNewletter1 = $('#newletter-show');
        let checkboxNewletter2 = $('#newletter-hidden');
        checkboxNewletter1.change(function() {
            checkboxNewletter2.prop('checked', this.checked);
        });

        let inputEmail1 = $('#email-show');
        let inputEmail2 = $('#billing_email');
        inputEmail1.change(function() {
            inputEmail2.val($(this).val());
            $(document.body).trigger('update_checkout');
        });

        let inputPhone1 = $('#phone-show');
        let inputPhone2 = $('#billing_phone');
        inputPhone2.val($(inputPhone1).val());
        inputPhone1.change(function() {
            inputPhone2.val($(this).val());
        });
    }

    $(document).ready(function() {
        $('.accordion-close').on('click', function() {
            $('#' + $(this).attr('data-close')).collapse('hide');
            $('#' + $(this).attr('data-open')).collapse('show');
        });
    });
});
const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();

jQuery(document).ready(function($) {
  

    // Open cart after redirect
    if (window.location.hash === '#cart') {
        new Offcanvas($('#offcanvasBag')).show();
    }

    $('.woocommerce-checkout #billing_state').on('change', function() {
        $(document.body).trigger('update_checkout');
    });

    $('.cart_checkout_details').on('change', 'input[name^="shipping_method"]', function() {
        $('body').trigger('update_checkout');
    });

    $(function() {
        let $orderReview = $(
            '.page-template-checkout-template .woocommerce-notices-wrapper:first'
        );
        $(document.body).on('updated_checkout', function(data) {
            $(
                'form.checkout .woocommerce-NoticeGroup-updateOrderReview .woocommerce-error, form.checkout .woocommerce-NoticeGroup-updateOrderReview .woocommerce-message'
            ).remove();
            $orderReview.append(data.messages);
        });
    });

    $('.woocommerce-checkout').on("click", ".woocommerce-error .showlogin", function() {
        let myCollapse = $('#accordionPanelsCheckout-collapseOne');
        new Collapse(myCollapse, {
            show: true
        });
    });
    $('.page-template-checkout-template').on("click", ".showlogin", function() {
        $('#username').focus();
    });
});

jQuery(document).ready(function($) {
    if ($('#accordionCircleMember').length) {
        changeChoiseCircleMember();
    }
});

function changeChoiseCircleMember() {
    let disabelText = my_ajax_object.disabel_text;
    let addToCartText = my_ajax_object.add_to_cart_text;
    jQuery('#add_to_cart_simple').data("circleMember", "annual");
    jQuery(document).on('change', 'input[type=radio][name=circle_member_accordion]', function() {
        if (this.value == "no") {
            jQuery('#add_to_cart_simple').data("circleMember", this.value);
            jQuery('#add_to_cart_simple').removeClass("disabled btn-outline-primary");
            jQuery('#add_to_cart_simple').text(addToCartText);
        } else {
            jQuery('#add_to_cart_simple').data("circleMember", jQuery('input[type=radio][name=circle_member]:checked').val());
            if (jQuery('input[type=radio][name=circle_member]:checked').val() == "monthly") {
                jQuery('#add_to_cart_simple').addClass("disabled btn-outline-primary");
                jQuery('#add_to_cart_simple').text(disabelText);
            }
        }
    });



    jQuery(document).on('change', 'input[type=radio][name=circle_member]', function() {
        jQuery('#add_to_cart_simple').data("circleMember", this.value);
        if (this.value == "monthly") {
            jQuery('#add_to_cart_simple').addClass("disabled btn-outline-primary");
            jQuery('#add_to_cart_simple').text(disabelText);
        } else {
            jQuery('#add_to_cart_simple').removeClass("disabled btn-outline-primary");
            jQuery('#add_to_cart_simple').text(addToCartText);
        }
    });
}

jQuery(document).ready(function($) {
    let dropdown = $('.custom-select-component');
    let listOfOptions = $('.custom-select-component__option');

    listOfOptions.on('click', function(event) {
        event.stopPropagation();
        let text = $(this).find(".custom-select-component__value").text();
        text = text.replace(/\s+/g, ' ').trim();
        $(".opened input").val(text);
        let optionValue = $(this).attr('data-value');
        let componentId = $(this).attr('data-component-id');
        let select = 'select#component_options_' + componentId + ' option[value=' + optionValue + ']';
        $(select).prop("selected", true);
        $(select).trigger('change');
        dropdown.removeClass('opened');

    });

    dropdown.on('click', function(event) {
        event.stopPropagation();
        dropdown.removeClass('opened');
        $(this).toggleClass('opened');
    });

    $(document).on('click', function(event) {
        if (!$(event.target).closest(dropdown).length) {
            dropdown.removeClass('opened');
        }
    });

    $('.composite-modal__body .composite_add_to_cart_button').on('click', function(event) {
        $(this).addClass('loading');
    });

    if ($('.submenu-block').length) {
        let lastScrollTop = 0;
        $(window).scroll(function(event) {
            let st = $(this).scrollTop();
            if (st > lastScrollTop) {
                $('.submenu-block').removeClass('position-sticky');
            } else {
                $('.submenu-block').addClass('position-sticky');
            }
            lastScrollTop = st;
        });
    }


    $.fn.visible = function(partial) {
        let $this = $(this),
            $window = $(window),
            viewTop = $window.scrollTop(),
            viewBottom = viewTop + $window.height(),
            _top = $this.offset().top,
            _bottom = _top + $this.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;
        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };
    if ($('.product-row-block .wrap-image').length) {
        $(window).scroll(function(event) {
            addClassShow(".wrap-image");
        });
        $(document).ready(function(event) {
            addClassShow(".wrap-image");
        });

        function addClassShow(elements) {
            $(elements).each(function(i, el) {
                var el = $(el);
                if (el.visible(true)) {
                    el.addClass("show");
                }
            });
        }
    }

});

jQuery(document).ready(function($) {
    $('input').on('input', function() {
        let input = $(this).val();
        if ('normalize' in String.prototype) {
            let normalizedInput = input.normalize("NFKC");
            $(this).val(normalizedInput);
        }
    });
});

function getCookie(cookieName) {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
}

function setCookie(cookieName, cookieValue, daysToExpire) {
    let expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    let expires = "expires=" + expirationDate.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

jQuery(document).ready(function($) {


    $('.btn-enrollment').on('click', function() {
        let linkRoutine = $(this).data('link');
        let productID = $(this).data('product');

        if (productID) {
            setCookie('enrollment_product_id', JSON.stringify(productID), 30);
        }

        window.location.href = linkRoutine;
    });



    let $products = [];

    //buy button routine
    if ($('.enrollment-kits-product-block-routine')) {

        $('.button-routines-buy').on('click', function() {

            let productId = $(this).data('id');

            if (!$(this).hasClass('added')) {
                $products.push(productId);
                $(this).addClass('added');
                $('.button-routines , .button-routines--fixed').addClass('js-check-button--true').removeClass('js-check-button--false');
                $('.button-routines , .button-routines--fixed').data('cards', $products);
                $('.button-routines , .button-routines--fixed').prop("disabled", false);
                $('.button-routines__message').addClass('hide').removeClass('show');
                $('.button-routines__label').addClass('show').removeClass('hide');
            } else {
                let index = $products.indexOf(productId);
                if (index !== -1) {
                    $products.splice(index, 1);
                }
                $(this).removeClass('added');
                $('.button-routines , .button-routines--fixed').data('cards', $products);
            }

            if ($products.length === 0 && $('.button-routines').hasClass('is-mandatory')) {
                $('.button-routines__message').addClass('show').removeClass('hide');
                $('.button-routines__label').addClass('hide').removeClass('show');
                $('.button-routines , .button-routines--fixed').addClass('js-check-button--false').removeClass('js-check-button--true');
                $('.button-routines , .button-routines--fixed').prop("disabled", true);
            }

            //console.log($products);

        });
    }




    //routine add to cart and redirect to checkout
    $('.button-routines , .button-routines--fixed').on('click', function(e) {
        e.preventDefault();
        $('.button-routines .spinner , .button-routines--fixed .spinner').removeClass('d-none');
        let routines_ids = $(this).data('cards');
        let enrollment_id = getCookie('enrollment_product_id');

        if (enrollment_id == null) {
            confirm('Please back to Enrollment page');
        } else {

            $.ajax({
                type: 'POST',
                url: wc_add_to_cart_params.ajax_url,
                data: {
                    'action': 'routines_cart',
                    'product_routines_ids': routines_ids,
                    'product_enrollment_id': enrollment_id
                },
                success: function(response) {

                    setCookie('enrollment_product_id', null, 0);
                    // Redirect to the checkout page
                    setTimeout(function() {
                        window.location.href = my_ajax_object.checkout_url;
                    }, 500);
                }
            });

        }
    });


    $(document.body).on('removed_from_cart', function() {

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'check_redirect_after_cart_update'
            },
            success: function(response) {
                if (response.redirect) {
                    window.location.href = response.redirect;
                }
            }
        });
    });

});

document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper(".swiper-slider-reviews__container", {
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const thumbsSwiper = new Swiper(".thumbs-slider", {
      spaceBetween: 12,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
    });
  
    const mainSwiper = new Swiper(".main-slider", {
      spaceBetween: 10,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  });
  
  function updateMenuTop() {
    if (window.innerWidth < 576) {
        const sentenceBlock = document.querySelector('.sentence-line-block');
        const header = document.querySelector('.wrapper-header');
        const menu = document.querySelector('.menu');

        if (!header || !menu) return;

        const headerRect = header.getBoundingClientRect();
        let totalTop = headerRect.bottom;

        menu.style.setProperty("top", `${totalTop}px`, "important");
    }
}

document.addEventListener("DOMContentLoaded", updateMenuTop);
window.addEventListener("resize", updateMenuTop);
window.addEventListener("scroll", updateMenuTop);

jQuery(document).ready(function ($) {
    let cartUpdatedByAjax = false; 
    $(".custom-submit").on("click", function (e) {
        e.preventDefault(); 

        let form = $(this).closest("form"); 
        let formData = form.serialize();
        $.ajax({
            type: "POST",
            url: wc_add_to_cart_params.ajax_url,
            data: formData + "&action=custom_add_composite_to_cart",
            beforeSend: function () {
                console.log("Sending AJAX request with data: ", formData);
                $(".custom-submit").addClass("loading");
            },
            success: function (response) {
                if (response.success || (response.data && response.data.message.includes("already in your cart"))) {
                    cartUpdatedByAjax = true; 
                    $(document.body).trigger("wc_fragment_refresh");
                }
            },
            error: function (xhr, status, error) {
                console.log("AJAX Error: ", xhr.responseText);
            },
            complete: function () {
                $(".custom-submit").removeClass("loading").addClass("added");
            },
        });

        return false; 
    });

    $(document.body).on("wc_fragments_refreshed", function () {
        if (cartUpdatedByAjax) {
            let offcanvasBag = $('#offcanvasBag');
            if ($(window).innerWidth() > 576 && !offcanvasBag.hasClass('show')) {
                let offcanvas = new Offcanvas($('#offcanvasBag'));
                offcanvas.show();
            }
            cartUpdatedByAjax = false; 
        }
    });
});


document.addEventListener("DOMContentLoaded", () => {
	const carousels = document.querySelectorAll(".slider-reviews-block .cards-wrap, .ingredients-block .cards-wrap");

	carousels.forEach((carousel) => {
		const originalItems = Array.from(carousel.children);

		const scrollToSecondCard = () => {
			const secondCard = carousel.querySelector(':scope > div:nth-child(2)');
			if (secondCard) {
				const containerRect = carousel.getBoundingClientRect();

				const scrollOffset = secondCard.offsetLeft - (containerRect.width / 2) + (secondCard.offsetWidth / 2);
				carousel.scrollTo({
					left: scrollOffset,
					behavior: "smooth"
				});
			}
		};

		setTimeout(scrollToSecondCard, 100);

		const checkScroll = () => {
			if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 50) {
				originalItems.forEach(item => {
					const clone = item.cloneNode(true);
					carousel.appendChild(clone);
				});
			}
		};

		carousel.addEventListener("scroll", checkScroll);
	});
});

document.addEventListener("DOMContentLoaded", function () {
    const lazyVideos = document.querySelectorAll('video');
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            
            video.querySelectorAll('source').forEach(source => {
              if (source.dataset.src) {
                source.src = source.dataset.src;
              }
            });
  
            video.load();
            obs.unobserve(video); 
          }
        });
      });
  
      lazyVideos.forEach(video => {
        video.querySelectorAll('source').forEach(source => {
          source.dataset.src = source.src;
          source.removeAttribute('src');
        });
        video.load(); 
        observer.observe(video);
      });
    }
  });